//======> Docementation <======//
registerBlockType('tornado/landing-media', {
    title: __('landing media ', 'tornado'),
    description: __('landing media ', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
        section_title : {
            type: 'string',
            selector: '.title',
            default: 'نبذه عن',
        },
        section_description : {
            type: 'string',
            selector: '.desc1',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
       
        section_image : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        section_image2 : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        section_image3 : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        section_image4 : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        section_image5 : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        section_image6 : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
        media1_control : {
            type: 'string',
            default : 'enable',
        },
        media2_control : {
            type: 'string',
            default : 'enable',
        },
       
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        const set_section_title = section_title => { setAttributes({section_title}) };
        const set_section_description = section_description => { setAttributes({section_description}) };
        const set_checklist = checklist => { setAttributes({checklist}) };
        const set_media1_control = media1_control => { setAttributes({media1_control}) };
        const set_media2_control = media2_control => { setAttributes({media2_control}) };
        //==== Images and icons Uploader ====//
        const section_image = (openEvent) => {
            return(<img src={ attributes.section_image } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Images and icons Uploader ====//
        const section_image2 = (openEvent) => {
            return(<img src={ attributes.section_image2 } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Images and icons Uploader ====//
        const section_image3 = (openEvent) => {
            return(<img src={ attributes.section_image3 } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Images and icons Uploader ====//
        const section_image4 = (openEvent) => {
            return(<img src={ attributes.section_image4 } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Images and icons Uploader ====//
        const section_image5 = (openEvent) => {
            return(<img src={ attributes.section_image5 } alt={ attributes.section_title } onClick={ openEvent }/>)
        };

        //==== Images and icons Uploader ====//
        const section_image6 = (openEvent) => {
            return(<img src={ attributes.section_image6 } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        var bgStyle = {
            backgroundImage:'url("'+attributes.section_image+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        var bgStyle2 = {
            backgroundImage:'url("'+attributes.section_image2+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        var bgStyle3 = {
            backgroundImage:'url("'+attributes.section_image3+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        var bgStyle4 = {
            backgroundImage:'url("'+attributes.section_image4+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        var bgStyle5 = {
            backgroundImage:'url("'+attributes.section_image5+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        var bgStyle6 = {
            backgroundImage:'url("'+attributes.section_image6+'")',
            bckgroundSize : 'cover',
            backgroundPosition:'center'
        };
        //==== Block Structure ====//
        return (
            <Panel>
                <PanelBody>
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                            {/* //=== Background Color Class ===// */}
                            
                            <SelectControl key="media1_control" label="اظهار / اخفاء البلوك الاول من الصور" value={ attributes.media1_control }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_media1_control}
                            />
                            <SelectControl key="media2_control" label="اظهار / اخفاء البلوك الثاني من الصور" value={ attributes.media2_control }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_media2_control}
                            />
                            {'الصوره الاولي'}
                            <MediaUpload render={({open}) => section_image(open)} value={ attributes.section_image }  onSelect={media => { setAttributes({section_image: media.url}); }} type="image" />
                            <br/><br/>
                            {'الصوره الثانيه'}
                            <MediaUpload render={({open}) => section_image2(open)} value={ attributes.section_image2 }  onSelect={media => { setAttributes({section_image2: media.url}); }} type="image" />
                            <br/><br/>
                            {'الصوره الثالثه'}
                            <MediaUpload render={({open}) => section_image3(open)} value={ attributes.section_image3 }  onSelect={media => { setAttributes({section_image3: media.url}); }} type="image" />
                            <br/><br/>
                            {'الصوره الرابعه'}
                            <MediaUpload render={({open}) => section_image4(open)} value={ attributes.section_image4 }  onSelect={media => { setAttributes({section_image4: media.url}); }} type="image" />
                            <br/><br/>
                            {'الصوره الخامسه'}
                            <MediaUpload render={({open}) => section_image5(open)} value={ attributes.section_image5 }  onSelect={media => { setAttributes({section_image5: media.url}); }} type="image" />
                            <br/><br/>
                            {'الصوره السادسه'}
                            <MediaUpload render={({open}) => section_image6(open)} value={ attributes.section_image6 }  onSelect={media => { setAttributes({section_image6: media.url}); }} type="image" />
                           
                        </PanelBody>
                    </InspectorControls>
                    <div className="section-medium" style={{backgroundColor:'rgba(0,0,0, 0.05)'}}>
                        <div className="container">
                            <div className="section-head tx-align-center">
                                <RichText tagName="h2" className="primary-color" onChange={ set_section_title } value={attributes.section_title} />
                                <RichText tagName="p" onChange={ set_section_description } value={attributes.section_description}/>
                            </div>
                            <div className="row">
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle}></div>
                                    </div>
                                </div>
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle2}></div>
                                    </div>
                                </div>
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle3}></div>
                                    </div>
                                </div>
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle4}></div>
                                    </div>
                                </div>
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle5}></div>
                                    </div>
                                </div>
                                <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                                    <div className="content-box">
                                        <div className="image media-element" style={bgStyle6}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
            <div className="section-medium" style="background-color: rgba(0,0,0, 0.05);">
                <div className="container">
                    <div className="section-head tx-align-center">
                        <h2 className="primary-color">{attributes.section_title}</h2>
                        <p>{attributes.section_description}</p>
                    </div>
                    <div className="row">
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image}></div>
                            </div>
                        </div>
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image2}></div>
                            </div>
                        </div>
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image3}></div>
                            </div>
                        </div>
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image4}></div>
                            </div>
                        </div>
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image5}></div>
                            </div>
                        </div>
                        <div className="service-block-new tx-align-center col-12 col-m-6 col-l-4">
                            <div className="content-box">
                                <div className="image media-element" data-src={attributes.section_image6}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});